import { render, staticRenderFns } from "./StageSelect.vue?vue&type=template&id=03f20bdf&lang=pug&"
import script from "./StageSelect.vue?vue&type=script&lang=js&"
export * from "./StageSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports